import React, { lazy, Suspense } from "react";

const LazyRequest_Menu = lazy(() => import("./Request_Menu"));
const LazyList_Requests = lazy(() => import("./List_Requests"));
const LazyAccept_Requests = lazy(() => import("./Accept_Requests"));
const LazyReject_Requests = lazy(() => import("./Reject_Requests"));
const LazyHRFormRequest = lazy(() => import("./HRFormRequest"));
export const Request_Menu = () => (
  <Suspense fallback="loading...">
    <LazyRequest_Menu />
  </Suspense>
);
export const List_Requests = () => (
  <Suspense fallback="loading...">
    <LazyList_Requests />
  </Suspense>
);
export const Accept_Requests = () => (
  <Suspense fallback="loading...">
    <LazyAccept_Requests />
  </Suspense>
);
export const Reject_Requests = () => (
  <Suspense fallback="loading...">
    <LazyReject_Requests />
  </Suspense>
);
export const HRFormRequest = () => (
  <Suspense fallback="loading...">
    <LazyHRFormRequest />
  </Suspense>
);
